<template>
  <div>
    <svg v-show="false" class="symbol">
      <symbol id="implant-systems">
        <g>
          <path class="cls-1" d="M129.12,23A93.35,93.35,0,1,1,23.91,52.83" />
          <path
            class="cls-1"
            d="M123.15,110.81a4.29,4.29,0,0,1-.51,6.26c-2,1.56-8.54,4.53-10.25,5s6.88,2.81,9.66,7-1.18,6.63-3.21,7.76a56.59,56.59,0,0,1-6.89,2.73s6.5,4.13,8.42,6.38,3.06,6.7-3.66,9.33-6.21,2.35-6.21,2.35,8.57,5.86,9.73,8.75c0,0-1,3-10.94,7a4.42,4.42,0,0,0-1.24,1.35c-.73,1.07-21.1,8.2-37.88-1.27l-2.78-2.21,4.66-4.36s-7.33-3.23-9.22-5.05-1.23-6.18-1.23-6.18,7-5.67,8.79-6.87-8.34-2.67-9.81-6.5,1.18-6.62,10-11.51c0,0-9.37-2.53-11.08-6s.47-7.12,8.95-11c0,0-8.86-4.8-9.9-6.66s-2.09-6.14,8.43-11.1c0,0-9.62-3.63-10.13-7.86-.73-6.09,9.71-10.12,9.11-10.67s-8-3.8-8.87-4.8-1.18-5.84.12-7.74,8.71-4,8.56-4.76-2.38-1.63-7.11-4.31-4.28-5.58-3-7.48,8-6.24,8-6.24A12.54,12.54,0,0,1,57,39.16V9.67a5.88,5.88,0,0,1,5.88-5.88h60.21a5.67,5.67,0,0,1,5.67,5.67V22.12"
          />
        </g>
      </symbol>
      <symbol id="kits-and-tools">
        <g>
          <path
            class="cls-1"
            d="M177.53,164.72A91.72,91.72,0,0,1,12.45,84.78"
          />
          <path
            class="cls-1"
            d="M13.13,85.26,7.38,64.39A18.45,18.45,0,0,1,20.23,41.75L155.2,4.5a18.48,18.48,0,0,1,22.65,12.85l24.29,88A18.46,18.46,0,0,1,189.29,128l-135,37.25a18.46,18.46,0,0,1-22.64-12.85"
          />
          <circle class="cls-1" cx="162.19" cy="104.83" r="8.44" />
          <circle class="cls-1" cx="148.04" cy="40.31" r="8.44" />
          <circle class="cls-1" cx="92.83" cy="55.15" r="8.44" />
          <circle class="cls-1" cx="43.84" cy="67.91" r="8.44" />
          <circle class="cls-1" cx="61.09" cy="134.16" r="8.44" />
          <circle class="cls-1" cx="103.19" cy="88.62" r="8.44" />
          <circle class="cls-1" cx="154.94" cy="74.12" r="8.44" />
          <circle class="cls-1" cx="52.81" cy="101.73" r="8.44" />
          <circle class="cls-1" cx="112.5" cy="120.36" r="8.44" />
        </g>
      </symbol>
      <symbol id="prosthetic-options">
        <g>
          <path class="cls-1" d="M149.88,205A93.33,93.33,0,0,1,36.57,57" />
          <path
            class="cls-1"
            d="M151.93,112.09c-7,1.17-22.28-1.8-28.78-36.22-2.59-13.69-.86-29.61,6.17-30.79"
          />
          <path
            class="cls-1"
            d="M151.13,204.27l4.7-39.4s1.47-4.14,5.21-5.35,7.62-3.07,8-8.55,4.15-20.46-11.5-25.94L119.73,5.63s-43.59-6.15-56.42,4l18.18,99.47s2.94,16-11.5,19.78l-.53,19.79s-.81,6.42,7.22,9.36a6.59,6.59,0,0,1,6.15,6.69c.26,6.41.8,11.49.8,11.49"
          />
        </g>
      </symbol>
      <symbol id="mguide">
        <g>
          <path class="cls-1" d="M8,34.44A93.3,93.3,0,1,1,32.51,179.08" />
          <polyline
            class="cls-1"
            points="32.76 143.7 50.55 119.36 3.79 113.86 108.31 35.92 89.06 166.12 64.3 129.44 33.13 178.04"
          />
        </g>
      </symbol>
      <symbol id="regenerative-solutions">
        <path
          d="M190.44,91.22C188,54.09,163.75,20.55,126.6,8.39c-49-16-101.82,11.16-118,60.73S18.87,171.87,67.84,187.9c36.28,11.87,74.69,0,98.76-27.08l-25.88-24.16s-32,10.76-60.43-8.43C52.88,109.73,55.09,59,55.09,59s41.8-9.47,64.9,16.6c14.86,16.77,7.18,43.6,7.18,43.6L90.48,90.35"
        />
      </symbol>
    </svg>

    <svg
      v-if="curIcon"
      :viewBox="curIcon.viewbox"
      :style="stroke ? `stroke:${stroke}` : ''"
    >
      <use class="ic-1" :xlink:href="`#${curIcon.id}`" x="0" y="0" />
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    stroke: String,
    fill: String
  },
  data() {
    return {
      icons: [
        {
          id: "implant-systems",
          viewbox: "0 0 194.23 207.83"
        },
        {
          id: "kits-and-tools",
          viewbox: "0 0 206.64 219.16"
        },
        {
          id: "prosthetic-options",
          viewbox: "0 0 173.53 225.11"
        },
        {
          id: "mguide",
          viewbox: "0 0 174.29 194.23"
        },
        {
          id: "regenerative-solutions",
          viewbox: "0 0 194.23 196.29"
        }
      ]
    };
  },
  computed: {
    curIcon() {
      return this.icons.find(icon => icon.id == this.id);
    }
  }
};
</script>
<style lang="stylus" scoped>

svg
  fill none
  stroke-linecap round
  stroke-linejoin round
  stroke-width 7.58px
  stroke gray_3
  transition stroke 0.3s ease-out
  max-height 50px
  max-width 100%
  /.el-size--medium &
    max-height 30px
  &.symbol
    display none
</style>
